import React from "react";
import StockRequisitionEditor from "./StockRequisitionEditor";

export default function EditStockRequisitionPopup({ requisitionId, businessUnitId, onClose }) {
  return <StockRequisitionEditor key={`${businessUnitId || ""}:${requisitionId}`} requisitionId={requisitionId} businessUnitId={businessUnitId} onClose={onClose} />;
}
